import { Document } from 'shell/models/person/document';
import { DocumentANSC } from 'shell/models/person/document-ANSC';
import { transformDocumentDigital } from 'shell/utils/consult-person/request-transformer/shared/transform-document-digital';
import { ActManagementForm } from 'shell/view-models/act-form';

export const transformerAttoNascitaFamily = (
  values?: ActManagementForm
):
  | {
      dataEvento?: string;
      atto?: Document;
      attoANSC?: DocumentANSC;
    }
  | undefined => {
  const withActPaper =
    values?.paper?.actYear ||
    values?.paper?.actPart ||
    values?.paper?.actSeries ||
    values?.paper?.actNumber ||
    values?.paper?.actVolume ||
    values?.paper?.actDate ||
    values?.paper?.actMunicipality?.description ||
    values?.paper?.actMunicipality?.id ||
    values?.paper?.actMunicipality?.province;

  const withActDigital = Boolean(values?.digital);
  return withActDigital || withActPaper
    ? {
        atto: withActPaper
          ? {
              anno: values.paper?.actYear || undefined,
              parte: values.paper?.actPart || undefined,
              serie: values.paper?.actSeries || undefined,
              numeroAtto: values.paper?.actNumber || undefined,
              volume: values.paper?.actVolume || undefined,
              dataFormazioneAtto: values.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
              trascritto: values.paper?.transcribed ? '1' : undefined,
              comuneRegistrazione: values.paper?.actMunicipality
                ? {
                    nomeComune: values.paper?.actMunicipality?.description || undefined,
                    codiceIstat: values.paper?.actMunicipality?.id || undefined,
                    siglaProvinciaIstat: values.paper?.actMunicipality?.province || undefined,
                  }
                : undefined,
            }
          : undefined,
        attoANSC: withActDigital
          ? transformDocumentDigital(values?.digital || undefined)
          : undefined,
      }
    : undefined;
};
